module.exports = __webpack_public_path__ + "static/media/BreastCancer_FFE3924.4c29a1c1.jpg";